// extracted by mini-css-extract-plugin
module.exports = {"titleWrapper":"style_titleWrapper__3l-Be","rowsWrapper":"style_rowsWrapper__2pWXg","rowWrapper":"style_rowWrapper__1i85A","text":"style_text__1WvQp"};